export const styleNewIn = {
    Container1NewIn : {
        gridTemplateColumns : {
            xl : '60% 40%',
            lg : '60% 40%',
            md : '60% 40%',
        },
        position : 'relative',
    },

    ButtonContainer : {
        width : 'full',
        py : ['20px','0px','40px','40px'],
        rounded : '0',
        border : '0',
        cursor : 'pointer',
        color:'white'
    },

    GridContent2 : {
        gridTemplateColumns : {
            sm : '100%',
            md : '100%',
            lg : '20% 80%',
            xl : '20% 80%',
        },
    }
}

